/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Koodi',
    COUNTERPARTS: 'Vastapuolet',
    CURRENT: 'Nykyinen',
    GENERAL_INFORMATION: 'Yleisiä tietoja',
    MANAGER: 'Johtaja',
    PREVIOUS: 'Edellinen',
    PRODUCTS: 'Tuotteet',
    REMUNERATION: 'Palkkaus',
    SUPERVISOR: 'Valvoja'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
